import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import { ProductCard } from './components';
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionGetDisplayAreasByType, actionResetDisplayAreas } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetBookingTypes } from 'actions';
import { actionCalendarNavReset } from 'actions';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(5)
    }
  },
  displaynone: {
    display: "none"
  }
}));

const ProductList = (props) => {

  const dispatch = useDispatch()
  const classes = useStyles();
  let history = useHistory();

  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const error = useSelector(state => state.reducerDisplayAreas.displayAreasError);
  const events = useSelector(state => state.reducerShopCart.events);
  const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
  const managemybkng = useSelector(state => state.reducerShopCart.managemybooking);

  useEffect(() => {
    actionGetDisplayAreasByType(dispatch, "bookingtypes", null, false);
    actionCalendarNavReset(dispatch);
  }, []);

  useEffect(() => {

    if (displayAreasState.loading == true) {
      actionStartAppLoader(dispatch);
    }
    else {
      actionEndAppLoader(dispatch);
    }

  })

  if (events && events.length < 1 && bookingTypes && bookingTypes.length > 0) {
    actionResetBookingTypes(dispatch);
  }

  const constredirect = (product) => {

    if (product.hasOwnProperty("UniqueBookingTypeID")) {
      props.history.push({
        pathname: '/calendar/' + product.UniqueBookingTypeID
      })
    }
    else {
      props.history.push({
        pathname: '/calendar/Area/' + product.DisplayAreaNo
      })
    }

  }

  const errorcancelhandle = () => {
    actionResetDisplayAreas(dispatch);
  }

  if (displayAreasState.displayAreas === undefined) {
    return <div>
      <ErrorHandling msg={error} open={error.length > 0 ? true : false}
        handleclose={errorcancelhandle} />
    </div>
  }

  return (

    <div className={classes.root}>
      <Grid
        container
        spacing={2}
        className={managemybkng === false ? '' : classes.displaynone}
      >

        {displayAreasState.displayAreas.map((area, i) => {
          return area.ShowOnline && area !== undefined ?
            <Grid item key={area.DisplayAreaNo}
              lg={4} md={6} xs={12}>
              <ProductCard area={area} callCalender={constredirect} />
            </Grid>
            : null
        })}

      </Grid>

      {managemybkng === true ?
        <Grid item xs={12} align="center">
          <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
            onClick={history.goBack()}></Button>
        </Grid>
        : null}
    </div>
  );
};

export default ProductList;
